import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'

import { RectangleNetworkBackground } from '../../../ui/background/rectangle-network'

import type { ClassNameProps, StyleProps } from '@root/shared/react'

type Props = {
  title: React.ReactNode
  description?: React.ReactNode
  onRetry?: () => void
  retryText?: string
} & ClassNameProps &
  StyleProps

export const DataTableMessage: React.FC<Props> = ({
  className,
  style,
  title,
  retryText,
  description,
  onRetry,
}) => {
  const { t } = useTranslation()

  return (
    <Root className={className} style={style}>
      <Container>
        <NoData>
          <Brackets inverse />
          {title}
          <Brackets />
        </NoData>
        {description ? <Text>{description}</Text> : undefined}
        {onRetry ? (
          <ButtonStyled
            variant="soft"
            size="xxs"
            radius="rounded"
            onClick={onRetry}
          >
            {retryText ?? t('common.retry')}
          </ButtonStyled>
        ) : undefined}
      </Container>
    </Root>
  )
}

const Root = styled.div`
  ${RectangleNetworkBackground}

  display: grid;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`

const ButtonStyled = styled(Button)`
  border-radius: 10px;
  background: var(--background-3);
  font-size: 10px;
  &:hover {
    background: var(--background-4);
  }
`

const Container = styled.div`
  display: grid;
  align-items: center;
  justify-items: center;
  justify-content: center;
  gap: 12px;

  transform: translateY(-1px);
`

const NoData = styled.div`
  color: var(--text-8);

  font-size: 12px;
  text-align: center;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;

  display: flex;
  align-items: center;
  gap: 4px;
`

const Text = styled.div`
  color: var(--text-8);

  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  text-transform: lowercase;
`

const Brackets = ({ inverse }: { inverse?: boolean }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="4"
      height="21"
      viewBox="0 0 4 21"
      fill="none"
      style={{ transform: inverse ? 'rotate(180deg)' : 'none' }}
    >
      <rect
        width="1"
        height="21"
        transform="matrix(-1 0 0 1 4 0)"
        fill="currentColor"
        opacity={0.5}
      />
      <rect
        width="1"
        height="4"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 0 0)"
        fill="currentColor"
        opacity={0.5}
      />
      <rect
        width="1"
        height="4"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 0 20)"
        fill="currentColor"
        opacity={0.5}
      />
    </svg>
  )
}
